import { cn } from "@/lib/utils";
import { STATUS } from "@/lib/status";

/** Thin horizontal utilisation bar (0–100 %). Instrument-style replacement for radial rings in lists. */
export const UtilBar = ({ value = 0, status = "running", className, showLabel = false, width }) => {
  const pct = Math.max(0, Math.min(100, value || 0));
  const cfg = STATUS[status] || STATUS.running;
  return (
    <div className={cn("flex items-center gap-2.5", className)} style={width ? { width } : undefined} aria-label={`${Math.round(pct)} % utnyttelse`}>
      <div className="util-track">
        <div className={cn("util-fill", cfg.bar)} style={{ width: `${pct}%` }} />
      </div>
      {showLabel ? <span className="metric w-8 shrink-0 text-right text-[11px] text-muted-foreground">{Math.round(pct)}%</span> : null}
    </div>
  );
};
